// src/Components/FixedBanner/FixedBanner.jsx
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const DESKTOP_MIN = 992;

const FixedBanner = ({ text = "Let's get started", link = "/contact" }) => {
  const [footerInView, setFooterInView] = useState(false);
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= DESKTOP_MIN
  );
  const location = useLocation();

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= DESKTOP_MIN);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!isDesktop) {
      setFooterInView(false);
      return;
    }

    const footer = document.querySelector("footer.creative-footer");
    if (!footer) {
      setFooterInView(false);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setFooterInView(entry.isIntersecting),
      { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
    );

    observer.observe(footer);
    return () => observer.disconnect();
  }, [location.pathname, isDesktop]);

  if (!isDesktop) {
    return null;
  }

  const isHidden = footerInView;

  return (
    <div
      className={`fixed right-0 z-40 top-1/2 -translate-y-1/2 transition-opacity duration-300 ${
        isHidden ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      aria-hidden={isHidden}
    >
      <Link
        to={link}
        className="block bg-[#22429a] text-white font-serif font-semibold px-6 py-4 shadow-xl hover:bg-[#1a2d7a] transition-colors duration-300 uppercase tracking-wider text-sm"
      >
        {text}
      </Link>
    </div>
  );
};

export default FixedBanner;
